module.exports = __webpack_public_path__ + "static/img/win3.ec4cb426.png";